import { ENV } from '../types/env.types';
import { isEnvMode } from '../utils/is-env';
const runInTargetEnv = ['production', 'staging'] as ENV['MODE'][];
export const googleAnalytics = {
  /**
   * Run the google analytics in the target environment
   * @default ['production']
   */
  runInTargetEnv,
  /**
   * activate analytics or not based on the current environment
   */
  shouldActivate: isEnvMode(runInTargetEnv),
} as const;
